import * as React from 'react'

import { Tag } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { CampaignStatus } from 'modules/ats/lib/vonq'

const statusLabel = (): Record<CampaignStatus, string> => {
  return {
    'in progress': i18n.t('ats.vonq.campaigns_list.statuses.in_progress'),
    offline: i18n.t('ats.vonq.campaigns_list.statuses.offline'),
    online: i18n.t('ats.vonq.campaigns_list.statuses.online'),
    'not processed': i18n.t('ats.vonq.campaigns_list.statuses.not_processed'),
  }
}

const statusColor = (): Record<CampaignStatus, keyof typeof Tag.Types> => {
  return {
    'in progress': Tag.Types.champagne,
    offline: Tag.Types.grey,
    online: Tag.Types.viridian,
    'not processed': Tag.Types.grey,
  }
}

interface Props {
  status: CampaignStatus
}

export const VonqCampaignStatusTag = ({ status }: Props) => {
  return (
    <Tag inline showCircle type={statusColor()[status]}>
      {statusLabel()[status]}
    </Tag>
  )
}
